import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { setListView } from '@/features/analysisMapSlice';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import { LayerType } from '@/views/map/layers/types';

/**
 * On mobile, automatically switch from list to map view when a span is
 * selected so the drawer opens over the map instead of overlaying the list.
 *
 * Only fires when `selectedItem` changes — each list tap dispatches a new
 * selectItem payload (even for the same span), so re-selects are detected.
 * Does NOT watch `isListView` to avoid a feedback loop that would prevent
 * the user from manually switching back to the list.
 */
export function useShowMapOnSpanSelect() {
  const dispatch = useAppDispatch();
  const isSmallScreen = useSmallScreen();
  const selectedItem = useAppSelector((s) => s.analysisMap.selectedItem);

  useEffect(() => {
    if (
      isSmallScreen &&
      selectedItem?.layer?.id === LayerType[LayerType.scan]
    ) {
      dispatch(setListView(false));
    }
  }, [selectedItem, isSmallScreen, dispatch]);
}
